import { render, staticRenderFns } from "./buyLink.vue?vue&type=template&id=63b2466c&scoped=true&"
import script from "./buyLink.vue?vue&type=script&lang=js&"
export * from "./buyLink.vue?vue&type=script&lang=js&"
import style0 from "./buyLink.vue?vue&type=style&index=0&id=63b2466c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2466c",
  null
  
)

export default component.exports